"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.TablePlaceholderRow = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var Table_1 = require("../Table");
function TablePlaceholderRow(props) {
    var colSpan = props.colSpan, message = props.message;
    var classes = styles_1.useStyles(exports.createStyles).classes;
    return (react_1.default.createElement(Table_1.TableRow, null,
        react_1.default.createElement(Table_1.TableCell, { colSpan: colSpan, style: classes.cell }, message)));
}
exports.TablePlaceholderRow = TablePlaceholderRow;
TablePlaceholderRow.defaultProps = {
    message: 'Nenhum registro encontrado',
};
exports.createStyles = function (theme) { return ({
    cell: {
        color: theme.pallete.text.secondary,
        fontStyle: 'italic',
        textAlign: 'center',
    },
}); };
//# sourceMappingURL=TablePlaceholderRow.js.map